import { Image } from '../../../AbstractElements';
import { dynamicImage } from "../../../Services"

export const dummytabledata = [
    {
        id: 1,
        name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/1.jpg"), alt: 'Generic placeholder image' }} />
            <div className="align-self-center">
                <div>Tags Deails </div>
            </div>
        </div>,
        date: '2023/04/27',
        invoice: '#PX0101',
        designation: 'System Architect',
        credit: <span className="f-w-700 font-success"><i className="icofont icofont-arrow-up"></i> 4.3%</span>,
        company: 'Hewlett packard',
        priority: <span className='badge badge-light-primary'>High</span>,
        budget: '$3142.00',

    },
    {
        id: 2,
        name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/2.png"), alt: 'Generic placeholder image' }} />
            <div className="align-self-center">
                <div>Tiger Nixon</div>
            </div>
        </div>,
        date: '2023/04/22',
        invoice: '#RF304f',
        designation: 'Maintenace service',
        credit: <span className="f-w-700 font-success"><i className="icofont icofont-arrow-up"></i> 5.6%</span>,
        company: 'Apple Inc.',
        priority: <span className='badge badge-light-danger'>Urgent</span>,
        budget: '$1234.00',

    },
    {
        id: 3,
        name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/3.jpg"), alt: 'Generic placeholder image' }} />
            <div className="align-self-center">
                <div>Ashton Cox</div>
            </div>
        </div>,
        date: '2023/05/21',
        invoice: '#DNJ480',
        designation: 'Junior Technical Author	',
        credit: <span className="f-w-700 font-danger"><i className="icofont icofont-arrow-down"></i> 2.4%</span>,
        company: 'Edinburgh',
        priority: <span className='badge badge-light-success'>Low</span>,
        budget: '$2345.00',

    },
    {
        id: 4,
        name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/3.jpg"), alt: 'Generic placeholder image' }} />
            <div className="align-self-center">
                <div>Brielle Willamson</div>
            </div>
        </div>,
        date: '2023/03/09',
        invoice: '#G189d0',
        designation: 'Senior Javascript Developer',
        credit: <span className="f-w-700 font-danger"><i className="icofont icofont-arrow-down"></i> 2.2%</span>,
        company: 'Microsoft',
        priority: <span className='badge badge-light-info'>Medium</span>,
        budget: '$7689.00',

    },
    {
        id: 5,
        name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/4.jpg"), alt: 'Generic placeholder image' }} />
            <div className="align-self-center">
                <div>Tiger Nixon</div>
            </div>
        </div>,
        date: '2023/04/10',
        invoice: '#31D8FFS',
        designation: 'Accountant',
        credit: <span className="f-w-700 font-success"><i className="icofont icofont-arrow-up"></i> 5.8%</span>,
        company: 'Tata Co.',
        priority: <span className='badge badge-light-primary'>High</span>,
        budget: '$2145.00',

    },
    {
        id: 6,
        name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/5.jpg"), alt: 'Generic placeholder image' }} />
            <div className="align-self-center">
                <div>Michel Morris</div>
            </div>
        </div>,
        date: '2023/06/12',
        invoice: '#G189D4',
        designation: 'General service',
        credit: <span className="f-w-700 font-success"><i className="icofont icofont-arrow-up"></i> 6.4%</span>,
        company: 'Google Inc.',
        priority: <span className='badge badge-light-danger'>Urgent</span>,
        budget: '$2578.00',

    },
    {
        id: 7,
        name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/6.jpg"), alt: 'Generic placeholder image' }} />
            <div className="align-self-center">
                <div>Glen Matney</div>
            </div>
        </div>,
        date: '2023/04/25',
        invoice: '#PX2101',
        designation: 'System Architect',
        credit: <span className="f-w-700 font-danger"><i className="icofont icofont-arrow-down"></i> 0.3%</span>,
        company: 'Mindtree Ltd.',
        priority: <span className='badge badge-light-success'>Low</span>,
        budget: '$6538.00',

    },
    {
        id: 8,
        name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/7.jpg"), alt: 'Generic placeholder image' }} />
            <div className="align-self-center">
                <div>Ashton Cox</div>
            </div>
        </div>,
        date: '2023/06/09',
        invoice: '#px0101',
        designation: 'System Architect',
        credit: <span className="f-w-700 font-success"><i className="icofont icofont-arrow-up"></i> 7.3%</span>,
        company: 'Wipro Ltd.',
        priority: <span className='badge badge-light-danger'>Urgent</span>,
        budget: '$2121.00',

    },
    {
        id: 9,
        name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/8.jpg"), alt: 'Generic placeholder image' }} />
            <div className="align-self-center">
                <div>Tiger Nixon</div>
            </div>
        </div>,
        date: '2023/01/11',
        invoice: '#G5384H',
        designation: 'General service',
        credit: <span className="f-w-700 font-success"><i className="icofont icofont-arrow-up"></i> 6.3%</span>,
        company: 'Edinburgh',
        priority: <span className='badge badge-light-primary'>High</span>,
        budget: '$9546.00',

    },
    {
        id: 10,
        name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/9.jpg"), alt: 'Generic placeholder image' }} />
            <div className="align-self-center">
                <div>Brielle Williamson</div>
            </div>
        </div>,
        date: '2023/04/02',
        invoice: '#E5384H',
        designation: 'System Architect',
        credit: <span className="f-w-700 font-danger"><i className="icofont icofont-arrow-down"></i> 3.3%</span>,
        company: 'Mphasis Ltd',
        priority: <span className='badge badge-light-info'>Medium</span>,
        budget: '$4587.00',

    },
    {
        id: 11,
        name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/10.jpg"), alt: 'Generic placeholder image' }} />
            <div className="align-self-center">
                <div>Charles Kubik</div>
            </div>
        </div>,
        date: '2023/05/01',
        invoice: '#JK384H',
        designation: 'System Architect',
        credit: <span className="f-w-700 font-danger"><i className="icofont icofont-arrow-down"></i> 2.3%</span>,
        company: 'Infosys Ltd.',
        priority: <span className='badge badge-light-success'>Low</span>,
        budget: '$3140.00',

    },
    {
        id: 12,
        name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/11.png"), alt: 'Generic placeholder image' }} />
            <div className="align-self-center">
                <div>Brielle Williamson</div>
            </div>
        </div>,
        date: '2023/07/04',
        invoice: '#HY5384H',
        designation: 'General service',
        credit: <span className="f-w-700 font-danger"><i className="icofont icofont-arrow-down"></i> 1.3%</span>,
        company: 'Edinburgh',
        priority: <span className='badge badge-light-success'>Low</span>,
        budget: '$3014.00',

    },
    {
        id: 13,
        name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/12.png"), alt: 'Generic placeholder image' }} />
            <div className="align-self-center">
                <div>Kevin Dawson</div>
            </div>
        </div>,
        date: '2023/04/06',
        invoice: '#KH384H',
        designation: 'System Architect',
        credit: <span className="f-w-700 font-success"><i className="icofont icofont-arrow-up"></i> 5.3%</span>,
        company: 'Infosys.',
        priority: <span className='badge badge-light-danger'>Urgent</span>,
        budget: '$2014.00',

    }
];

export const tableColumns = [
    {
        name: 'Sr. No.',
        selector: (row, index) => index + 1,
        sortable: true,
        center: true,
        minWidth: '1rem',
      },
      {
        name: 'Waypoint ID',
        selector: row => row.wpt_id,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
    //   {
    //     name: 'Transit Point ID',
    //     selector: row => row.tpt_id,
    //     sortable: true,
    //     center: true,
    //     minWidth: '2rem',
    //   },
      {
        name: 'Sequence No',
        selector: row => row.seq_no,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Waypoint Name',
        selector: row => row.wpt_name,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Session ID',
        selector: row => row.session_id_daywise,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Activity',
        selector: row => row.activity,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      
      {
        name: 'Journey Time (mins)',
        selector: row => row.journey_time_in_mins,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },

      {
        name: 'Description',
        selector: row => row.understand_desc,
        sortable: true,
        center: true,
        minWidth: '4rem',
      },
      {
        name: 'River Section',
        selector: row => row.river_sect,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Avg Time Spent',
        selector: row => row.avg_time_spent_min,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Place',
        selector: row => row.place,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Latitude',
        selector: row => row.lat,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Longitude',
        selector: row => row.lon,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Plot & Street',
        selector: row => row.plot_start_name,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Town',
        selector: row => row.town,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'District',
        selector: row => row.dist,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'State',
        selector: row => row.state,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Pincode',
        selector: row => row.pincode,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Previous Distance',
        selector: row => row.prev_walk_wpt_dist,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Next Distance',
        selector: row => row.next_walk_wpt_dist,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Next Time',
        selector: row => row.next_walk_wpt_time,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Trail Type',
        selector: row => row.trail_type,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Importance',
        selector: row => row.importance,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Landmark',
        selector: row => row.landmark,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Thumbnail',
        selector: row => row.thumbnail,
        sortable: true,
        center: true,
        minWidth: '2rem',
        cell: row => row.thumbnail && <img src={row.thumbnail} alt="Thumbnail" style={{ width: '50px', height: '50px' }} />,
      },
      {
        name: 'Police Station Distance',
        selector: row => row.dist_police_stn,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Bus Stand Distance',
        selector: row => row.dist_bus_stnd,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Railway Station Distance',
        selector: row => row.dist_rail_stn,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Accommodation',
        selector: row => row.d_reg_acmd,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Eateries',
        selector: row => row.d_reg_eateries,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Medical Store',
        selector: row => row.d_reg_medical,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Clinic',
        selector: row => row.d_reg_clinic,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Hospital',
        selector: row => row.d_reg_hosp,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Description',
        selector: row => row.wpt_desc,
        sortable: true,
        center: true,
        minWidth: '6rem',
      },
      {
        name: 'Vivekji Description',
        selector: row => row.vivekji_desc,
        sortable: true,
        center: true,
        minWidth: '6rem',
      },
      {
        name: 'Category',
        selector: row => row.wpt_category_name,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Type',
        selector: row => row.wpt_type_name,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Popular For',
        selector: row => row.popular_for,
        sortable: true,
        center: true,
        minWidth: '4rem',
      },
      {
        name: 'Short Description',
        selector: row => row.short_desc,
        sortable: true,
        center: true,
        minWidth: '4rem',
      },
      {
        name: 'Created On',
        selector: row => row.created_on,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
    //   {
    //     name: 'Updated On',
    //     selector: row => row.updated_on,
    //     sortable: true,
    //     center: true,
    //     minWidth: '2rem',
    //   },
      {
        name: 'Category ID',
        selector: row => row.wpt_category_id,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Type ID',
        selector: row => row.wpt_type_id,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Type IDs',
        selector: row => row.wpt_type_ids,
        sortable: true,
        center: true,
        minWidth: '2rem',
      },
      {
        name: 'Action',
        selector: row => row.action,
        sortable: true,
        center: true,
        minWidth: '12rem',
    },
];

const handleEdit = (wpt_id) => {
    console.log('Edit', wpt_id);
    // Implement edit functionality
};

const handleDelete = (wpt_id) => {
    console.log('Delete', wpt_id);
    // Implement delete functionality
};

